import { createApp } from 'vue'

import TheIcon from '@/components/Container/TheIcon'
import TheScreen from '@/components/Container/TheScreen'
import TheSection from '@/components/Container/TheSection'

import events$ from '@/services/Events'
import Tracking from '@/plugins/Tracking'
import i18n, { selectedLanguage, setLanguageGetter } from '@/plugins/i18n'

import useI18n from '@/hooks/useI18n'
import useSnackbar from '@/hooks/useSnackbar'

import clickOutside from '@/directives/ClickOutside'
import tooltip from '@/directives/Tooltip'
import swipeCarousel from '@/directives/SwipeCarousel'
import sanitizeHtmlDirective from '@/directives/sanitizeHtml'
import preventTypingWithValue from '@/directives/PreventTypingWithValue'
import scrollToTop from '@/directives/ScrollToTop'

import { EVENT_PET } from '@/config/events'
import { PACKAGE } from '@/config/constants'

// HOOKS
const { getContent } = useI18n()
const { addNotification } = useSnackbar()

let isInitialized = false
// eslint-disable-next-line no-undef
const npmVersion = __NPM_VERSION__

async function appInit(appInstance, appName) {
  if (!isInitialized) {
    console.info(
      `%c ⚑ sani%ctas SALES:${appName}`,
      'font-weight:bold;color:#00765A;',
      'font-weight:bold;color:#5BAC26;',
      `v${npmVersion}`
    )

    await getContent({ app: PACKAGE.ERRORS, language: selectedLanguage.value })

    events$.on(EVENT_PET.ERROR, message => {
      const currentPath = window.location.pathname
      const isReentryOrUnsubscribe = currentPath.includes('/reentry/') || currentPath.includes('/unsubscribe/')
      
      if (!isReentryOrUnsubscribe) {
        addNotification({
          key: message.key,
          type: message.type,
          payload: message.payload,
        })
      }
    })
    isInitialized = true
  }
  return appInstance
}

async function setup({ appInstance, appName, languageGetter }) {
  appInstance.provide('version$', npmVersion)
  appInstance.provide('appName$', appInstance._component.__name)

  // add global directives
  appInstance.directive('click-outside', clickOutside)
  appInstance.directive('tooltip', tooltip)
  appInstance.directive('swipe-carousel', swipeCarousel)
  appInstance.directive('sanitize-html', sanitizeHtmlDirective)
  appInstance.directive('prevent-typing-with-value', preventTypingWithValue)
  appInstance.directive('scroll-to-top', scrollToTop)

  // add global components
  appInstance.component('TheIcon', TheIcon)
  appInstance.component('TheScreen', TheScreen)
  appInstance.component('TheSection', TheSection)

  // add global plugins
  setLanguageGetter(languageGetter)
  appInstance.use(i18n)

   if (!isInitialized) {
    appInstance.use(Tracking)
  }

  return await appInit(appInstance, appName)
}

export { createApp, setup }
